/**
 * Built lazily: `config.js` imports every config module up front, so validating
 * at module scope would throw during local dev, where VITE_ULTIVERSE_DOMAIN is
 * legitimately unset. The check belongs at selection time, not import time.
 */
export function buildProdConfig() {
    const domain = import.meta.env.VITE_ULTIVERSE_DOMAIN;

    if (!domain) {
        throw new Error(
            'VITE_ULTIVERSE_DOMAIN is not set. A production build without it silently ' +
                'produces an API base URL of "https://undefined/api". Pass it as a Docker ' +
                'build arg (see Dockerfile) or set it in the build environment.'
        );
    }

    const baseUrl = `https://${domain}`;

    return {
        apiUrl: `${baseUrl}/api`,
        lightningServiceHost: `${baseUrl}/lightning`,
        url: baseUrl,
        searchEndpoint: '/search',
        apiGatewayPath: '/api'
    };
}
